exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* UU5.Forms.Text */\n.uu5-forms-text-glyphicon {\n  margin-top: 0.1em;\n  margin-bottom: 1em;\n}\n.uu5-forms-text-glyphicon:after {\n  display: block;\n  position: relative;\n  content: '';\n  clear: both;\n}\n.uu5-forms-text-glyphicon-left .uu5-forms-text-glyphicon-link {\n  left: 0;\n}\n.uu5-forms-text-glyphicon-left .uu5-forms-input-form-item {\n  padding-left: 2.4em;\n}\n.uu5-forms-text-glyphicon-right .uu5-forms-text-glyphicon-link {\n  right: 0;\n}\n.uu5-forms-text-glyphicon-right .uu5-forms-input-form-item {\n  padding-right: 2.4em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./forms/text-glyphicon.less
// module id = 334
// module chunks = 0